import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  orderServ: yup.number().required(),
});
